var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUiCircleNumberBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.665,
    height: 44.529,
    viewBox: "0 0 45.665 44.529",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "UI_Circle_number_bg",
    d: "M12.774,0,.443,11.236,0,27.778l6.225,13.1,15.826,3.652,15.4-6.856,8.218-15.392L38.92,3.444,20.719.1Z",
    transform: "translate(0 0)",
    fill: "#b8748c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiCircleNumberBg);
export default __webpack_public_path__ + "static/media/UI_Circle_number_bg.2350da73863bbbcdcad10e5c8ac31c54.svg";
export { ForwardRef as ReactComponent };